"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isOpen;
function isOpen(_ref) {
  var open = _ref.open;
  if (typeof open !== 'boolean') {
    return true;
  }
  return open;
}